import { render } from "./ChangeProductDiscountModal.vue?vue&type=template&id=277d8b64"
import script from "./ChangeProductDiscountModal.vue?vue&type=script&lang=js"
export * from "./ChangeProductDiscountModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__